import seriesOptions from './series'

import { toYYYYMMDD } from '../utils/day'

const smas = [
  { id: 'sma-main-5', linkedTo: 'main', period: 5 },
  { id: 'sma-main-10', linkedTo: 'main', period: 10 },
  { id: 'sma-main-20', linkedTo: 'main', period: 20 },
  { id: 'sma-main-60', linkedTo: 'main', period: 60 },
  { id: 'sma-main-120', linkedTo: 'main', period: 120 },
  { id: 'sma-main-150', linkedTo: 'main', period: 150 },
  { id: 'sma-main-180', linkedTo: 'main', period: 180 },
]

const vsmas = [
  { id: 'vsma-volume-5', linkedTo: 'volume', period: 5, visible: false },
  {
    id: 'vsma-volume-10',
    linkedTo: 'volume',
    period: 10,
    visible: false,
  },
  {
    id: 'vsma-volume-20',
    linkedTo: 'volume',
    period: 20,
    visible: false,
  },
  {
    id: 'vsma-volume-60',
    linkedTo: 'volume',
    period: 60,
    visible: false,
  },
  {
    id: 'vsma-volume-120',
    linkedTo: 'volume',
    period: 120,
    visible: false,
  },
  { id: 'vsma-volume-150', linkedTo: 'volume', period: 150, visible: false },
  { id: 'vsma-volume-180', linkedTo: 'volume', period: 180, visible: false },
]

const signals = [
  { id: 'custom-sma-icons' },
  {
    id: 'high-low-icons',
    dataLabels: {
      enabled: true,
      formatter: function () {
        const chart = this.series.chart
        const iconsSeries = chart.get('high-low-icons')

        let isHigh = false
        const currentIndex = this.x === iconsSeries.xData[0] ? 0 : 1
        const standardIndex = 1 - currentIndex

        if (
          iconsSeries.yData[currentIndex] > iconsSeries.yData[standardIndex]
        ) {
          isHigh = true
        }

        const date = toYYYYMMDD(chart.dateLabels[this.x] + _KST_MSEC)
        return `<span style="color:${
          isHigh ? 'red' : 'blue'
        };">${this.y.toLocaleString()} (${date})</span>`
      },
    },
  },
]

const highchartsOptions = {
  series: [
    ...signals.map((signal) => seriesOptions.getScatter(signal)),
    ...smas.map((sma) => seriesOptions.getSMA(sma)),
    ...vsmas.map((vsma) => seriesOptions.getVSMA(vsma)),
  ],
}

export default highchartsOptions

const _KST_MSEC = 1000 * 60 * 60 * 9
